import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-payments-payments-response-data-dialog',
  templateUrl: './payments-payments-response-data-dialog.component.html',
  styleUrls: ['./payments-payments-response-data-dialog.component.scss']
})
export class PaymentsPaymentsResponseDataDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<PaymentsPaymentsResponseDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      console.dir(data);
    }

  ngOnInit() {
  }

}
